module.exports = __webpack_public_path__ + "static/08-883c5731c48520aec38eebed8ab376bb.jpg";